import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ADMIN_CONTEXT, ADMIN_LOGIN_ROUTE, EXTERNAL_AUTH_PROVIDER_ROUTE, EXTERNAL_AUTH_ROUTE, MAINTENANCE_CONTEXT, PAIRING_CONTEXT, SIGNAGE_CONTEXT, SIGNAGE_PREVIEW_PREFIX } from './core/consts/route-names';
import { workingStateGuard } from './core/guards/working-state.guard';
import { State } from './core/types/state';
import { InitializationComponent } from './core/views/initialization/initialization.component';
import { MaintenanceComponent } from './core/views/maintenance/maintenance.component';
import { Page404Component } from './core/views/page404/page404.component';
import { SIGNAGE_CONTEXT_DEFAULT, SIGNAGE_CONTEXT_PREVIEW } from './signage/consts/signage-context.provider';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: InitializationComponent
  },
  // Redirects required because these routes are hardcoded in `platform-api` library or in the backend.
  {
    path: ADMIN_LOGIN_ROUTE,
    redirectTo: `${ADMIN_CONTEXT}/${ADMIN_LOGIN_ROUTE}`
  },
  {
    path: `${EXTERNAL_AUTH_ROUTE}/:transactionId`,
    redirectTo: `${ADMIN_CONTEXT}/${EXTERNAL_AUTH_ROUTE}/:transactionId`
  },
  {
    path: `${EXTERNAL_AUTH_ROUTE}/${EXTERNAL_AUTH_PROVIDER_ROUTE}/:providerName/:providerId`,
    redirectTo: `${ADMIN_CONTEXT}/${EXTERNAL_AUTH_ROUTE}/${EXTERNAL_AUTH_PROVIDER_ROUTE}/:providerName/:providerId`
  },
  {
    path: MAINTENANCE_CONTEXT,
    component: MaintenanceComponent
  },
  {
    path: PAIRING_CONTEXT,
    canMatch: [workingStateGuard(State.PAIRING)],
    loadChildren: () => import('./pairing/pairing.module').then(m => m.PairingModule)
  },
  {
    path: SIGNAGE_CONTEXT,
    canMatch: [workingStateGuard(State.SIGNAGE)],
    providers: [SIGNAGE_CONTEXT_DEFAULT],
    loadChildren: () => import('./signage/signage.module').then(m => m.SignageModule)
  },
  {
    path: `${SIGNAGE_PREVIEW_PREFIX}/layout/:layoutId`,
    providers: [SIGNAGE_CONTEXT_PREVIEW],
    loadChildren: () => import('./signage/signage.module').then(m => m.SignageModule)
  },
  {
    path: ADMIN_CONTEXT,
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: '**',
    component: Page404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
